import _ from 'lodash';
import { httpMethods, requestAsync } from 'redux-query';
import { SubmissionError } from 'redux-form';
import { UPDATE_DEFAULT } from 'dash-front/requery/actions';

const defaultTransform = key => v => ({
    [key]: v
});

const defaultUpdate = key => ({
    [key]: UPDATE_DEFAULT.LATEST
});

export const createApiFetch = ({ url, key, queryKey = key, configOptions = {} }) => ({
    url,
    transform: defaultTransform(key),
    queryKey,
    force: true,
    update: defaultUpdate(key),
    ...configOptions
});

export const createPostRequest = ({ url, body, key = '', configOptions = {} }) => {
    const { options } = configOptions;
    return {
        url,
        body,
        queryKey: key,
        update: defaultUpdate(key),
        force: true,
        options: { ...options, method: httpMethods.POST },
        ...configOptions
    };
};

export const handleServerError = response => {
    const { status } = response;
    if (status >= 400) {
        const { body } = response;
        throw new SubmissionError(body);
    }
    if (!status) {
        throw new SubmissionError({ _error: 'Server is not responding' });
    }
};

const transformById = (dataKey, idKey) => data => {
    const { [idKey]: id } = data || {};
    if (id === undefined) {
        return {};
    }
    return {
        [dataKey]: { [id]: data }
    };
};

export const createApiFetchById = ({ url, id, key, idKey = 'id', body }) => {
    const requestConfig = {
        url,
        key,
        body,
        queryKey: key + '/' + id,
        force: false,
        transform: transformById(key, idKey),
        update: {
            [key]: (prev, curr) => {
                return { ...prev, ...curr };
            }
        }
    };
    return requestAsync(requestConfig);
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/actions/helpers.js
 **/